import { render, staticRenderFns } from "./StorageIntro.vue?vue&type=template&id=16ceaf08&scoped=true&"
import script from "./StorageIntro.vue?vue&type=script&lang=js&"
export * from "./StorageIntro.vue?vue&type=script&lang=js&"
import style0 from "./StorageIntro.vue?vue&type=style&index=0&id=16ceaf08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ceaf08",
  null
  
)

export default component.exports